import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["title", "id"]

  setFields(event) {
    const link = event.currentTarget

    this.titleTarget.textContent = link.dataset.cloneReportTypeType
    this.idTarget.value = link.dataset.cloneReportTypeId
  }
}
